
export default function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-yellow-400/20 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4 group">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/dadfa7b8e8bbab8ae3e8df395caac6f8/302de87561c96b1946ecbbc97f2148e3.png" 
                  alt="ARK Construction Consultants Inc Logo"
                  className="w-14 h-14 object-contain transition-all duration-300 group-hover:scale-105 group-hover:rotate-2 drop-shadow-md"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-yellow-600/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-lg"></div>
              </div>
              <div>
                <h3 className="text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 group-hover:from-yellow-300 group-hover:via-yellow-400 group-hover:to-yellow-500 transition-all duration-300">
                  ARK Construction Consultants Inc™
                </h3>
              </div>
            </div>
            <p className="text-slate-400 mb-4 max-w-md">
              Building foundations for sovereign futures through AI-integrated smart infrastructure and sustainable development solutions worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-yellow-400 hover:bg-yellow-400 hover:text-slate-900 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-yellow-400 hover:bg-yellow-400 hover:text-slate-900 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-yellow-400 hover:bg-yellow-400 hover:text-slate-900 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-slate-400 hover:text-yellow-400 transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#services" className="text-slate-400 hover:text-yellow-400 transition-colors cursor-pointer">Services</a></li>
              <li><a href="#expertise" className="text-slate-400 hover:text-yellow-400 transition-colors cursor-pointer">Expertise</a></li>
              <li><a href="#contact" className="text-slate-400 hover:text-yellow-400 transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-slate-400">
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-yellow-400 mt-1"></i>
                <div>
                  <p className="text-sm">2935 E. Main Street, Unit 91133</p>
                  <p className="text-sm">Bexley, Ohio 43209 USA</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-yellow-400"></i>
                <p className="text-sm">754-234-3691</p>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-yellow-400"></i>
                <p className="text-sm">hr@arkconstructionconsultants.space</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">
            © 2025 ARK Construction Consultants Inc™ — Global Smart & Green Infrastructure Solutions
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-slate-400 hover:text-yellow-400 text-sm transition-colors mt-4 md:mt-0 cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
